import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import ThemeContext from "../../Context/theme/ThemeContext";
import { formatPrice, trimDescription } from "../../Files/UseFunction";
import ProfilePic from "./ProfilePic";

const MarketplaceCart = ({ item }) => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  return (
    <div
      className={`font-pop rounded-lg overflow-hidden cursor-pointer transition-transform duration-200 hover:shadow-lg ${
        theme === "dark" ? "bg-black text-white" : "bg-white"
      }`}
      onClick={() => {
        navigate(`/user-dashboard/marketplace/AddDetail/${item._id}`);
      }}
    >
      {/* Image Container */}
      <div className="relative w-full h-48">
        <img
          src={item?.Images && item?.Images[0]?.img}
          alt={item?.Title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content Container */}
      <div className="p-4">
        {/* Header: Seller Info and Price */}
        <div className="flex justify-between items-start mb-3">
          {/* Seller Info */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
              <ProfilePic
                profilePhoto={item?.User?.ProfilePhoto}
                name={item?.User?.FirstName}
              />
            </div>
            <div className="flex flex-col">
              <h3 className="text-sm font-medium line-clamp-1">
                {item?.User?.FirstName} {item?.User?.LastName}
              </h3>
              <span className="text-xs text-gray-500">
                Level {item?.User?.Level || 1}
              </span>
            </div>
          </div>

          {/* Price */}
          <div
            className={`text-base font-semibold ${
              theme === "dark" ? "text-white" : "text-gray-900"
            }`}
          >
            {item.formattedPrice}
          </div>
        </div>

        {/* Title */}
        {/* <h2 className="text-base font-medium line-clamp-2 min-h-[2.5rem]">
          {trimDescription(item.Title, 70)}
        </h2> */}
      </div>

      {/* Bottom Border */}
      <div className="h-1 w-full bg-gradient-to-r from-primarygreen/20 to-primarygreen/40" />
    </div>
  );
};

export default MarketplaceCart;
